<div class="token-verification-page">
    <div class="content">
        <h1>EZ DOCS Account Activation</h1>

        <div>
            <p>
                Please enter your dealer code below. For security purposes, this dealer code must be the one that
                corresponds with the link you used to access
                EZ DOCS.
            </p>

            <form [formGroup]="form" *ngIf="attemptsRemaining > 0" (ngSubmit)="submit()">
                <mat-form-field>
                    <mat-label>Dealer Code</mat-label>
                    <input class="dealer-code" matInput formControlName="oemDealerId" (keyup)="oemDealerCodeChanged()"
                        (change)="oemDealerCodeChanged()" />
                </mat-form-field>
            </form>

            <p>If you have any questions or need help, please reach out to us.</p>

            <div class="support-wrap">
                <p><b>EZ DOCS Support</b></p>

                <p>Phone: {{ tenantSupportPhone }}</p>
                <p>Email: {{ tenantSupportEmail }}</p>
                <p><em>Our support team is available Monday through Friday from 8am to 8pm and Saturdays from 10am to
                        6pm (all times Eastern).</em></p>
            </div>

            <div class="btn-wrap">
                <button mat-button class="secondary" (click)="cancel()">Cancel</button>
                <button mat-button class="primary" (click)="submit()"
                    [disabled]="!(oemDealerId?.length > 0)">Submit</button>
            </div>
        </div>
    </div>
</div>